// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607140133/js/" + chunkId + "." + {"44":"0ec32d60","225":"96358471","481":"1732ea77","486":"ea776530","770":"d64c24c3"}[chunkId] + ".0.1269523826426091.chunk.js";
};